<template>
  <vx-card class="mt-5">
    <div class="p-6 invoice-detail">
      <h3>#{{ form.id }}</h3>

      <div
        v-if="isRequireApproval"
        class="flex flex-wrap-reverse justify-end flex-grow mt-6"
      >
        <div class="flex flex-wrap-reverse">
          <vs-button color="danger" class="mr-3" @click="reject"
            >Reject</vs-button
          >
          <vs-button color="primary" class="mr-3" @click="approve"
            >Approve</vs-button
          >
        </div>
      </div>

      <!-- Overview Info -->
      <vx-card class="mt-base" title="Overview" no-shadow card-border>
        <div class="pl-3 pr-3 vx-row">
          <div class="w-full md:w-1/3 sm:w-1/2">
            <label class="text-sm text-black">Transaction ID:</label><br />
            <p>{{ form.id }}</p>
          </div>
          <div class="w-full md:w-1/3 sm:w-1/2">
            <label class="text-sm text-black">Reference ID:</label><br />
            <p>{{ form.paymentReference }}</p>
          </div>
          <div class="w-full mt-3 md:w-1/3 sm:w-1/2">
            <label class="text-sm text-black">Amount:</label><br />
            <p class="text-bold">
              {{ (form.amount ? form.amount : 0) | toCurrency(form.currency ? form.currency : '') }}
            </p>
          </div>
          <div class="w-full md:w-1/3 sm:w-1/2">
            <label class="text-sm text-black">Status:</label><br />
            <vs-chip
              :color="getTransactionStatusColor(form.status)"
              class="product-order-status"
            >
              {{ form.status }}
            </vs-chip>
          </div>
          <div class="w-full mt-3 md:w-1/3 sm:w-1/2">
            <label class="text-sm text-black">Created At:</label><br />
            <p>{{ form.createdAt | moment('DD MMM YYYY, hh:mm A') }}</p>
          </div>
          <div class="w-full mt-3 md:w-1/3 sm:w-1/2">
            <label class="text-sm text-black">Paid At:</label><br />
            <p>{{ form.paidAt | moment('DD MMM YYYY, hh:mm A') }}</p>
          </div>
          <div class="w-full mt-3 md:w-1/3 sm:w-1/2">
            <label class="text-sm text-black">Type:</label><br />
            <p>{{ form.type }}</p>
          </div>
          <div v-if="form.provider" class="w-full mt-3 md:w-1/3 sm:w-1/2">
            <label class="text-sm text-black">Provider:</label><br />
            <p>{{ form.provider }}</p>
          </div>
          <div v-if="form.remarks" class="w-full mt-3 md:w-1/3 sm:w-1/2">
            <label class="text-sm text-black">Remarks:</label><br />
            <p>{{ form.remarks }}</p>
          </div>
        </div>
      </vx-card>

      <!-- Customer Info -->
      <vx-card class="mt-base" title="Customer" no-shadow card-border>
        <div class="pl-3 pr-3 vx-row">
          <div class="w-full mt-3 md:w-1/2 sm:w-1/2">
            <label class="text-sm text-black">ID:</label><br />
            <p>
              <a v-if="form.customer" @click="onViewCustomerDetail(form.customer.customerId)">{{
                form.customer ? form.customer.customerId : ''
              }}</a>
            </p>
          </div>
          <div class="w-full mt-3 md:w-1/2 sm:w-1/2">
            <label class="text-sm text-black">Name:</label><br />
            <p>{{ form.customer.name }}</p>
          </div>
          <div class="w-full mt-3 md:w-1/2 sm:w-1/2">
            <label class="text-sm text-black">Email Address:</label><br />
            <p>{{ form.customer.emailAddress }}</p>
          </div>
          <div class="w-full mt-3 md:w-1/2 sm:w-1/2">
            <label class="text-sm text-black">Phone:</label><br />
            <p>{{ form.customer.phone }}</p>
          </div>
        </div>
      </vx-card>

      <!-- Items Info -->
      <vx-card class="mt-base" no-shadow card-border>
        <h4 class="mb-3 card-title">Items ({{ form.items.length }})</h4>
        <vs-table stripe ref="table" :data="form.items">
          <template slot="thead">
            <vs-th sort-key="type">Type</vs-th>
            <vs-th sort-key="invoiceNo">Invoice No</vs-th>
            <vs-th sort-key="amount">Amount</vs-th>
          </template>

          <template slot-scope="{ data }">
            <tbody>
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td>
                  <p class="product-name">{{ tr.docType }}</p>
                </vs-td>
                <vs-td>
                  <p class="product-name">{{ tr.docNo }}</p>
                </vs-td>
                <vs-td>
                  <p class="product-name">
                    {{ (tr.amount ? tr.amount : 0) | toCurrency(form.currency ? form.currency : '') }}
                  </p>
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>
      </vx-card>

      <!-- Attachment List -->
      <vx-card
        v-if="this.form.attachmentUrls"
        class="mt-base"
        no-shadow
        card-border
      >
        <h4 class="mb-3 card-title">
          Attachments ({{ this.form.attachmentUrls.length }})
        </h4>
        <vs-table stripe ref="table" :data="this.form.attachmentUrls">
          <template slot="thead">
            <vs-th>Attachment</vs-th>
            <vs-th>Action</vs-th>
          </template>
          <template>
            <tbody>
              <vs-tr
                v-for="(tr, index) in this.form.attachmentUrls"
                :key="index"
              >
                <vs-td>
                  <p class="product-name">{{ tr.name }}</p>
                </vs-td>
                <vs-td>
                  <feather-icon
                    icon="EyeIcon"
                    svgClasses="w-5 h-5 hover:text-success stroke-current"
                    class="ml-2"
                    @click.stop="showAttachment(tr.path)"
                  />
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>
      </vx-card>
    </div>
  </vx-card>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import GenericUpload from '@/views/components/override/GenericUpload.vue'
import vSelect from 'vue-select'
import TransactionStatus from '@/mixins/transaction-status'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Array,
      default: () => {},
    },
  },
  components: {
    VuePerfectScrollbar,
    GenericUpload,
    vSelect,
  },
  mixins: [TransactionStatus],
  data() {
    return {
      isUpdate: false,
      form: {
        attachmentUrls: null,
        isRequireManualApproval: false,
      },
      settings: {
        // perfect scrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
    }
  },
  computed: {
    scrollbarTag() {
      return this.$store.getters.scrollbarTag
    },
    isRequireApproval() {
      return (
        this.form.status === 'pending approval' &&
        this.form.isRequireManualApproval
      )
    },
  },
  created() {
    this.fetchRecord(this.$route.params.id)
  },
  methods: {
    async fetchRecord(id) {
      let response = await this.$store
        .dispatch('transactions/fetchRecord', id)
        .catch(err => {
          console.error(err)
        })
      this.form = response.data
    },
    async approve() {
      let response = await this.$store
        .dispatch('transactions/approveRecord', this.$route.params.id)
        .catch(err => {
          this.$vs.notify({
            color: 'danger',
            title: 'Fail',
            text: err.message,
          })
        })

      if (response) {
        this.$vs.notify({
          color: 'success',
          title: 'Success',
          text: 'Transaction has been approved successfully',
        })
        this.form = response
      }
    },
    async reject() {
      let response = await this.$store
        .dispatch('transactions/rejectRecord', this.$route.params.id)
        .catch(err => {
          this.$vs.notify({
            color: 'danger',
            title: 'Fail',
            text: err.message,
          })
        })

      if (response) {
        this.$vs.notify({
          color: 'success',
          title: 'Success',
          text: 'Transaction has been approved successfully',
        })
        this.form = response
      }
    },
    onViewCustomerDetail(customerId) {
      this.$router.push('/customers/' + encodeURIComponent(customerId)).catch(() => {})
    },
    showAttachment(filepath) {
      if (filepath) {
        window.open(filepath, '_blank')
        return
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.text-error {
  color: #e85600;
}
</style>
